<template>
    <v-layout>
        <v-flex>
            <v-footer
                    absolute
                    color="#373737"
                    style="font-size: 16px;line-height: 24px;font-weight: bold"
                    dark
            >
                <v-col
                        style="text-align: center"
                        cols="12"

                >
                    <span>Copyright © 2020. All Rights Reserved</span>
                </v-col>
            </v-footer>

        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>
